export class FeedbackStatisticsEmojiItem {
  icon = '';
  color = '';
  percent = 0;
  count = 0;
}
